import axios from 'axios';
import CONSTS from '../../config/constants';
import Env from '../../config/environment';

const { API_APP } = CONSTS.SERVICES;
const env = Env();
const version = env.app.version;

export const sendContract = document => {
  return axios.post(`/b/docs/${version}/documents`, document, {
    headers: {
      service: API_APP,
    },
  });
};

export const getContractList = (params) => axios.get(`/b/docs/${version}/documents?page=${params.page}&limit=${params.limit}&status=${params.statusName}&startDate=${params.startDate}&endDate=${params.endDate}`, {
  headers: {
    service: API_APP,
  },
});

export const getNotificationList = (params) => axios.get(`/b/docs/${version}/documents?limit=${params.limit}&status=${params.statusName}${params.idModified}${params.sendDate}`, {
  headers: {
    service: API_APP,
  },
});

export const fetchContract = (id) => axios.get(`/b/docs/${version}/documents/${id}`, {
  headers: {
    service: API_APP,
  },
});

export const sendSign = (params) => axios.post(`/b/docs/${version}/documents/sign`, {
  docID: params.id,
  ...params.rol,
  signature: params.signature,
  token: params.token,
}, {
  headers: {
    service: API_APP,
  },
});

export const sendDemur = (params) => axios.post(`/b/docs/${version}/documents/object`, {
  docID: params.id,
  ...params.rol,
  objectionMessage: params.msg,
}, {
  headers: {
    service: API_APP,
  },
});

export const verifyContractToken = (token) => axios.get(`/b/docs/${version}/documents/token/${token}`, {
  headers: {
    service: API_APP,
  },
});

export const sendUpdateContract = (id, document, token) => {
  return axios.post(`/b/docs/${version}/documents/${id}/edit`, { ...document, token: token }, {
    headers: {
      service: API_APP,
    },
  });
};

export const rejectObj = (params) => axios.post(`/b/docs/${version}/documents/dismiss`, {
  docID: params.id,
  token: params.token,
}, {
  headers: {
    service: API_APP,
  },
});

export const sendContractNotarisa = (params) => axios.post(`/b/private/${version}/admin/send`, {
  docID: params.id,
}, {
  headers: {
    service: API_APP,
  },
});

export const sendAdminUpdateContract = (id, document) => {
  return axios.post(`/b/private/${version}/admin/${id}/edit`, document, {
    headers: {
      service: API_APP,
    },
  });
};

export const cancel = (params) => axios.post(`/b/private/${version}/admin/cancel`, {
  docID: params.id,
}, {
  headers: {
    service: API_APP,
  },
});

export const searchContract = (filter, value) => axios.get(`/b/docs/${version}/documents/?${filter}=${value}`, {
  headers: {
    service: API_APP,
  },
});

export const modifyPdf = (params) => axios.post(`/b/private/${version}/admin/modifyPdf`, {
  ...params
}, {
  headers: {
    service: API_APP,
  },
});

export const saveDraft = document => {
  return axios.post(`/b/docs/${version}/draft`, document, {
    headers: {
      service: API_APP,
    },
  });
};

export const getDraft = token => axios.get(`/b/docs/${version}/draft/${token}`, {
  headers: {
    service: API_APP,
  },
});

export const getPrice = params => axios.post(`/b/docs/${version}/clientContracts/getCustomPrice`, {
  ...params
}, {
  headers: {
    service: API_APP,
  },
});

export const getDefaultPrice = params => axios.get(`/b/docs/${version}/contracts/${params}`, {
  headers: {
    service: API_APP,
  },
});

// PDF =================================================================================
export const getContractPdf = (id) => axios.get(`/b/docs/${version}/documents/${id}/download`, {
  headers: {
    service: API_APP,
  },
});

export const getPreview = (params) => axios.post('/b/pdf/preview/rentContract',
  params,
  {
    headers: {
      service: API_APP,
    },
  }
);

export const getDomainCertPdf = (id) => axios.get(`/b/docs/${version}/domainCertificate/${id}/download`,
  {
    headers: {
      service: API_APP,
    },
  }
);
